export class SchoolAttendanceMonitorItem {
    index: number;
    status: number;
    serviceConceptId: number;
    serviceName: string;
    serviceId: number;
    average: number;
    edited: boolean;
}